import React, { PureComponent, Fragment } from 'react';
import { withTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Link } from 'formlabs-web-components/Link';
import { Picture } from 'formlabs-web-components/Media';
import { InteractiveDiv } from 'formlabs-web-components/Wrapper';
import { GridContainer, Grid, Cell } from 'formlabs-web-components/Grid';
import debounce from 'lodash/debounce';
import { compose } from 'redux';
import { connect } from 'react-redux';

import CountryContext from '../../context/country';
import StoreButton from '../storefront/MenuButton';
import Cart from '../storefront/Cart';
import MenuSignIn from './MenuSignIn';
import DescriptionDropdown from './DescriptionDropdown';
import ImageGridDropdown from './ImageGridDropdown';
import Dropdown from './Dropdown';
import StickyNav from './StickyNav';
import PageSubNav from './PageSubNav';
import SiteSelector from './SiteSelector';

import logoBlack from '../../../../public/logo_black.svg';
import logoWhite from '../../../../public/logo_white.svg';

import './HeaderMenu.module.css';

const preventDefaultHandler = event => {
  event.preventDefault();
};

const pickLogo = color => {
  const logos = {
    black: logoBlack,
    white: logoWhite
  };

  if (logos[color]) return logos[color];
  return logos['black'];
};

class HeaderMenu extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hoverOptions: -1,
      mobile: false,
      stickyNav: false,
      dropdownOpen: false,
      siteSelect: {
        hover: false,
        open: false
      }
    };
    this.child = React.createRef();
    this.containerRef = React.createRef();
  }

  static contextType = CountryContext;

  handleScrollStickyNav = () => {
    this.setState(
      {
        stickyNav: window.scrollY >= 80 && !this.state.mobile
      },
      () => {
        if (this.state.stickyNav && this.state.dropdownOpen) {
          this.handleHoverMenuClose();
        }
      }
    );
  };

  debouncedStickyNav = debounce(this.handleScrollStickyNav, 200);

  handleHoverMenu = i => {
    this.setState({
      hoverOptions: i,
      dropdownOpen: true,
      siteSelect: { hover: false, open: false }
    });
  };

  handleHoverSiteSelect = () => {
    this.setState({ siteSelect: { hover: true } });
  };
  handleClickSiteSelect = () => {
    this.setState({
      siteSelect: { hover: true, open: !this.state.siteSelect.open },
      hoverOptions: -1,
      dropdownOpen: false
    });
  };

  handleHoverMenuClose = () => {
    this.setState({
      dropdownOpen: false,
      siteSelect: { hover: false, open: false }
    });
  };

  componentDidMount() {
    window.addEventListener('resize', this.debouncedResize);
    window.addEventListener('scroll', this.debouncedStickyNav);
    window.dispatchEvent(new Event('resize'));
    this.handleScrollStickyNav();
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.debouncedResize);
    window.removeEventListener('scroll', this.debouncedStickyNav);
  }

  resize = () => {
    this.setState({ mobile: window.innerWidth <= 1050 });
  };

  debouncedResize = debounce(this.resize, 100);

  UNSAFE_componentWillReceiveProps(newProps) {
    const oldProps = this.props;
    if (oldProps.slug !== newProps.slug) {
      this.handleHoverMenuClose();
    }
  }

  render() {
    const {
      typeColor,
      data,
      additionalHeaderMenu,
      secondaryMenu,
      slug,
      countrySite,
      t,
      stickyNavShown,
      isAuthenticated
    } = this.props;
    const {
      stickyNav,
      mobile,
      hoverOptions,
      dropdownOpen,
      siteSelect
    } = this.state;
    const { path, storePage } = this.context;
    const { hover, open } = siteSelect;
    const sites = [
      {
        name: 'Formlabs',
        url: 'https://formlabs.com',
        displayUrl: 'formlabs.com'
      },
      {
        name: 'Dental',
        url: 'https://dental.formlabs.com',
        displayUrl: 'dental.formlabs.com'
      }
    ];
    const isDental = process.env.RAZZLE_CMS_SITE === 'dental';

    return (
      <Fragment>
        <div
          styleName={`header ${dropdownOpen ? 'black ' : typeColor} ${
            dropdownOpen && data[hoverOptions].children.length < 1
              ? 'white-bg'
              : ''
          }`}
          role="navigation"
        >
          <GridContainer>
            <div styleName="static-header" ref={this.containerRef}>
              {!mobile && (
                <Fragment>
                  <div styleName="left-menu">
                    <Link to={path}>
                      <Picture
                        largeImage={pickLogo(
                          dropdownOpen ? 'black' : typeColor
                        )}
                        lazyload={false}
                        alt={t('Formlabs Logo')}
                      />
                    </Link>
                    {isDental && (
                      <SiteSelector
                        open={open}
                        sites={sites}
                        handleHoverSiteSelect={this.handleHoverSiteSelect}
                        handleClickSiteSelect={this.handleClickSiteSelect}
                      />
                    )}
                    <div styleName="main-menu">
                      {data.map((menuItem, i) => {
                        return (
                          <div
                            styleName={`${
                              hoverOptions === i && dropdownOpen
                                ? 'has-dropdown'
                                : ''
                            } main-menu-item`}
                            key={`main-menu-div-${i}`}
                          >
                            <Link
                              to={menuItem.url}
                              styleName="top-level-menu"
                              openInNewWindow={menuItem.newWindow}
                              onMouseEnter={() => this.handleHoverMenu(i)}
                            >
                              {menuItem.name}
                            </Link>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  <div
                    styleName="right-menu"
                    onMouseEnter={this.handleHoverMenuClose}
                    role="menu"
                    tabIndex="0"
                  >
                    <div>
                      {additionalHeaderMenu.map(menuItem => {
                        return (
                          <Link
                            to={menuItem.url}
                            styleName="top-level-menu"
                            key={`${menuItem.url} ${menuItem.name}`}
                          >
                            {menuItem.name}
                          </Link>
                        );
                      })}
                    </div>
                    <MenuSignIn
                      typeColor={dropdownOpen ? 'black' : typeColor}
                    />
                    {storePage && <StoreButton />}
                  </div>
                </Fragment>
              )}
              {mobile && (
                <MobileHeaderMenu
                  typeColor={typeColor}
                  data={data}
                  countrySite={countrySite}
                  t={t}
                  slug={slug}
                  isAuthenticated={isAuthenticated}
                  white={isDental}
                  sites={sites}
                  isDental={isDental}
                />
              )}
            </div>
            {secondaryMenu && (
              <div styleName="page-sub-nav-outer-container">
                <PageSubNav
                  secondaryMenu={secondaryMenu}
                  stuck={stickyNav}
                  slug={slug}
                  typeColor={typeColor}
                  mobile={mobile}
                />
              </div>
            )}
          </GridContainer>
        </div>
        {!mobile &&
          hoverOptions >= 0 &&
          data[hoverOptions].menuStyle === 'default' && (
            <Dropdown
              hoverOptions={hoverOptions}
              dropdownOpen={dropdownOpen}
              handleHoverMenuClose={this.handleHoverMenuClose}
              ref={this.child}
              data={data}
            />
          )}
        {!mobile &&
          hoverOptions >= 0 &&
          data[hoverOptions].menuStyle === 'image-grid' && (
            <ImageGridDropdown
              hoverOptions={hoverOptions}
              dropdownOpen={dropdownOpen}
              handleHoverMenuClose={this.handleHoverMenuClose}
              ref={this.child}
              data={data}
            />
          )}
        {!mobile &&
          hoverOptions >= 0 &&
          data[hoverOptions].menuStyle === 'description' && (
            <DescriptionDropdown
              hoverOptions={hoverOptions}
              dropdownOpen={dropdownOpen}
              handleHoverMenuClose={this.handleHoverMenuClose}
              ref={this.child}
              data={data}
            />
          )}
        {stickyNavShown && (
          <StickyNav
            stuck={stickyNav}
            secondaryMenu={secondaryMenu}
            slug={slug}
            countrySite={countrySite}
          />
        )}
        <div
          styleName={`overlay selector-overlay open-${hover}`}
          onMouseEnter={this.handleHoverMenuClose}
        />
      </Fragment>
    );
  }
}

export default compose(
  connect(state => {
    return {
      isAuthenticated: state.auth.isAuthenticated
    };
  }),
  withTranslation()
)(HeaderMenu);

class MobileHeaderMenu extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      cartOpen: false,
      selected: -1,
      siteSelect: {
        hover: false,
        selectOpen: false
      }
    };
  }

  static contextType = CountryContext;
  handleClickSiteSelect = () => {
    this.setState({
      siteSelect: {
        selectOpen: !this.state.siteSelect.selectOpen
      },
      hoverOptions: -1,
      dropdownOpen: false
    });
  };
  openCart = () => {
    window.scrollTo({ top: 0 });
    const body = window.document.getElementsByTagName('body')[0];
    body.addEventListener('touchmove', preventDefaultHandler, {
      passive: false
    });
    this.setState({ cartOpen: true });
  };

  closeCart = () => {
    this.setState({ cartOpen: false });
    const body = window.document.getElementsByTagName('body')[0];
    body.removeEventListener('touchmove', preventDefaultHandler);
  };

  openSubMenu(i) {
    const { selected } = this.state;
    if (selected !== i) {
      this.setState({ selected: i });
    } else {
      this.setState({ selected: -1 });
    }
  }
  toggleMenu = () => {
    const { open } = this.state;
    if (open) {
      document.documentElement.style.cssText =
        "overflow: visible; position: ''; height: '';";
      document.body.style.cssText =
        "overflow: visible; position: ''; height: '';";
      this.setState({ selected: -1 });
    } else {
      document.documentElement.style.cssText =
        'overflow: hidden; position: relative; height: 100%;';
      document.body.style.cssText =
        'overflow: hidden; position: relative; height: 100%;';
    }
    this.setState({
      open: !open,
      siteSelect: {
        selectOpen: false
      }
    });
  };
  UNSAFE_componentWillReceiveProps(newProps) {
    const oldProps = this.props;
    if (oldProps.slug !== newProps.slug) {
      this.setState({ open: false });
      document.documentElement.style.cssText =
        "overflow: visible; position: ''; height: '';";
      document.body.style.cssText =
        "overflow: visible; position: ''; height: '';";
      this.setState({ selected: -1 });
    }
  }
  render() {
    const {
      typeColor,
      data,
      countrySite,
      slug,
      t,
      isAuthenticated,
      white,
      sites,
      isDental
    } = this.props;
    const {
      open,
      selected,
      cartOpen,
      siteSelect: { selectOpen }
    } = this.state;
    const { path, storePage } = this.context;
    return (
      <Fragment>
        <div styleName="logo-link">
          <Link to={path}>
            <Picture
              largeImage={pickLogo(typeColor)}
              lazyload={false}
              alt={t('Formlabs Logo')}
            />
          </Link>
        </div>
        {storePage && (
          <Fragment>
            <div styleName="store-button">
              <StoreButton
                mobile
                color={typeColor}
                openCart={this.openCart}
                closeCart={this.closeCart}
                isExternalCartOpen={cartOpen}
              />
            </div>
            <div styleName={classnames('cart-holder', { open: cartOpen })}>
              {cartOpen && (
                <div styleName="cart">
                  <div styleName="cart-inner">
                    <Cart />
                  </div>
                  <InteractiveDiv
                    handler={this.closeCart}
                    styleName="cart-close"
                  >
                    <span styleName="cart-close-icon">
                      <i className="fl-navigate_next" />
                    </span>
                    <span styleName="cart-close-text">{t('Hide cart')}</span>
                  </InteractiveDiv>
                </div>
              )}
            </div>
          </Fragment>
        )}
        <InteractiveDiv
          styleName={`hamburger ${open ? 'open' : ''} ${
            typeColor && !open
              ? `${typeColor}-nav`
              : white
              ? 'black-nav'
              : 'white-nav'
          }`}
          handler={this.toggleMenu}
          aria-label={t('mobile menu toggle')}
        >
          <span />
          <span />
          <span />
          <span />
        </InteractiveDiv>
        <div
          styleName={classnames('mobile-menu', {
            'mobile-open': open,
            'mobile-white': white
          })}
        >
          <div styleName="mobile-menu-logo">
            <Link to="/">
              <Picture
                largeImage={pickLogo(white ? 'black' : 'white')}
                lazyload={false}
                alt={t('Formlabs Logo')}
              />
            </Link>
            {isDental && (
              <Fragment>
                <SiteSelector
                  open={selectOpen}
                  sites={sites}
                  handleHoverSiteSelect={this.handleHoverSiteSelect}
                  handleClickSiteSelect={this.handleClickSiteSelect}
                />
                {selectOpen && <div styleName="mobile-overlay" />}
              </Fragment>
            )}
          </div>
          {data.map((menuItem, i) => (
            <div key={`main-menu-div-${i}`}>
              {menuItem.children.length >= 1 && (
                <div
                  styleName={`main-menu-item-mobile ${
                    i === selected ? 'selected' : ''
                  } ${selected >= 0 ? 'submenu-opened' : ''}`}
                >
                  <span
                    id={i}
                    styleName={`top-level-mobile-menu ${
                      menuItem.children.length > 0 ? 'has-children' : ''
                    }`}
                    onClick={() => this.openSubMenu(i)}
                    onKeyUp={() => this.openSubMenu(i)}
                    role="button"
                    tabIndex="0"
                  >
                    {menuItem.name}
                    {menuItem.children.length > 0 && (
                      <i className="fl-navigate_next" />
                    )}
                  </span>
                  <div styleName="second-level">
                    {menuItem.children.map((menuItem, i) => {
                      const link = {
                        id: menuItem.name.replace(/\s/g, ''),
                        to: menuItem.url,

                        onClick: slug
                          ? slug.pathname === menuItem.url
                            ? this.toggleMenu
                            : ''
                          : ''
                      };
                      return (
                        <div styleName={``} key={`main-menu-div-${i}`}>
                          <Link
                            {...link}
                            styleName={`second-level-mobile-menu ${
                              menuItem.children.length > 0 ? 'has-children' : ''
                            }`}
                          >
                            {menuItem.name}
                          </Link>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              {menuItem.children.length === 0 && (
                <div
                  styleName={`main-menu-item-mobile ${
                    i === selected ? 'selected' : ''
                  } ${selected >= 0 ? 'submenu-opened' : ''}`}
                  key={`main-menu-div-${i}`}
                >
                  <Link to={menuItem.url}>{menuItem.name}</Link>
                </div>
              )}
            </div>
          ))}
          <div key={`main-menu-div`}>
            <div
              styleName={`main-menu-item-mobile ${
                selected >= 0 ? 'submenu-opened' : ''
              }`}
            >
              <span styleName={`top-level-mobile-menu`}>
                <Link to="/dashboard">
                  {isAuthenticated ? t('Dashboard') : t('Sign In')}
                </Link>
              </span>
            </div>
          </div>
          <div styleName="mobile-buttons">
            <Grid direction="x">
              <Cell smallSize={12} backgroundColor="blue">
                {storePage && (
                  <Link to={storePage} style={white ? { color: '#fff' } : {}}>
                    {t('Store')}
                  </Link>
                )}
              </Cell>
              <Cell
                smallSize={12}
                backgroundColor={white ? 'light-grey' : 'dark-grey'}
              >
                <Link to={`/change-region/?from=${slug}`}>
                  <div styleName="change-region">
                    <Picture
                      largeImage={countrySite.regionFlag}
                      width={22}
                      alt={t('Change Region')}
                    />{' '}
                    <p>{t('Change Region')}</p>
                  </div>
                </Link>
              </Cell>
            </Grid>
          </div>
        </div>
      </Fragment>
    );
  }
}
